/*
REFERENCE DOCS
https://www.algolia.com/doc/ui-libraries/autocomplete/introduction/getting-started/
*/

custom.algoliaAutocomplete = (function () {
    const indexName = (name) =>{
        return algoliaShopify.config.index_prefix + name;
    }
    /**
     * custom.algoliaAutocomplete.init() method
     */
    const init = () => {
        const { autocomplete, getAlgoliaResults } = window['@algolia/autocomplete-js'];
        
        const searchClient = algoliasearch(
            algoliaShopify.config.app_id,
            algoliaShopify.config.search_api_key
        );
        const autocompleteContainer = document.getElementById('algoliaAutocomplete');
        const autocompleteResults = document.getElementById('AutoCompleteResult');
        const autocompleteSearch = autocomplete({
            container: autocompleteContainer,
            panelContainer: autocompleteResults,
            insights: true,
            detachedMediaQuery: 'none',
            placeholder: 'Search for Products and Collections',
            // Trigger a custom event when the query changes
            onStateChange({state}) {
                $('#autocompleteSearchInput').val(state.query ? state.query : '');
                if(state.query.length > 0) {
                    $('.search-panel__suggestions').addClass('hidden');
                    // window.pubsub.trigger('openAutoCompleteDropdown');
                    // setIsOpen(true);
                } else {
                    $('.search-panel__suggestions').removeClass('hidden');
                }
            },
            shouldPanelOpen({ state }) {
                return state.query.length > 0;
            },
            onSubmit({ state, event }) {
                if(state.query.length > 0) {
                    // Prevent default form submission
                    event.preventDefault();
                    $('#autocompleteSearchForm').trigger('submit');
                }
            },
            // Autocomplete sources
            getSources({ query }) {
                return [
                    {
                        sourceId: 'collections',
                        getItems() {
                            return getAlgoliaResults({
                                searchClient,
                                queries: [
                                {
                                    indexName: indexName('collections'),
                                    params: {
                                        query,
                                        hitsPerPage: 6,
                                    },
                                },
                                ],
                            });
                        },
                        getItemUrl({ item }) {
                            return `/collections/${item.handle}`;
                        },
                        templates: {
                            header({ html }) {
                                return html`<p class="utility-xsmall utility-xsmall--emphasis content-default mb-4 tracking-3 uppercase">Collections & Collaborations</p>`;
                            },
                            item({ item, html }) {
                                return html`<a class="utility-xsmall utility-xsmall--emphasis content-subtle tracking-075" href="/collections/${item.handle}">${custom.utils.titleCaseWithExceptions(item.title)}</a>`;
                            },
                            noResults({ html }) {
                                return html`<p class="utility-xsmall utility-xsmall--emphasis content-subtle tracking-075">No Collection or Collaboration Found</p>`;
                            },
                        },
                    },
                    {
                        sourceId: 'editorial',
                        getItems() {
                            return getAlgoliaResults({
                                searchClient,
                                queries: [
                                {
                                    indexName: indexName('articles'),
                                    params: {
                                        query,
                                        hitsPerPage: 3,
                                    },
                                },
                                ],
                            });
                        },
                        getItemUrl({ item }) {
                            return `/blog/${item.blog.handle}/${item.handle}`;
                        },
                        templates: {
                            header({ html }) {
                                return html`<p class="utility-xsmall utility-xsmall--emphasis content-default mb-4 tracking-3 uppercase">Editorial</p>`;
                            },
                            item({ item, html }) {
                                return html`<a class="utility-xsmall utility-xsmall--emphasis content-subtle tracking-075" href="/blog/${item.blog.handle}/${item.handle}">${item.title}</a>`;
                            },
                            noResults({ html }) {
                                return html`<p class="utility-xsmall utility-xsmall--emphasis content-subtle tracking-075">No Article Found</p>`;
                            },
                        },
                    },
                ];
            },
            // Default Navigator API implementation
            navigator: {
              navigate({ itemUrl }) {
                window.location.assign(itemUrl);
              },
              navigateNewTab({ itemUrl }) {
                const windowReference = window.open(itemUrl, '_blank', 'noopener');
          
                if (windowReference) {
                  windowReference.focus();
                }
              },
              navigateNewWindow({ itemUrl }) {
                window.open(itemUrl, '_blank', 'noopener');
              },
            },
        });
    };

    // Make public
    return {
        init,
    };
})();



// WEBPACK FOOTER //
// ./src/scripts/src/custom/algolia-autocomplete.js